//REGISTER
export const POST_REGISTER = "/post-register"
export const CREATE_STRIPE_CUSTOMER = "/kickstart-user"

//LOGIN
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

export const GET_JOURNAL_NOTE = "/journal"
export const POST_JOURNAL_NOTE = "/journal"
export const DELETE_JOURNAL_NOTE= "/journal"

//PROJECTS
export const GET_JOURNAL = "/journal"
export const GET_JOURNAL_ENTRY = "/journal"
export const POST_JOURNAL_ENTRY = "/journal"
export const GET_JOURNAL_DAYS = "/journal/list"
export const GET_JOURNAL_BY_DAY = "/journal/day"
export const GET_JOURNAL_SEARCH = "/journal/search"
export const UPDATE_JOURNAL_ENTRY = "/journal"
export const DELETE_JOURNAL_ENTRY = "/journal"

export const PROFILE = "/profile"
export const POST_USER_LOGIN = "/userlogin"

export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/events"
export const UPDATE_EVENT = "/events"
export const DELETE_EVENT = "/events"
export const DELETE_MONTH_EVENTS = "/events/bulk"
export const GET_CATEGORIES = "/categories"

// dashboard
export const GET_DASHBOARD = "/dashboard"
export const ADD_DASHBOARD_ITEM = "/dashboard"
export const DELETE_DASHBOARD_ITEM = "/dashboard"

// REFERRAL
export const GET_REFERRAL = "/referrals"
export const ADD_REFERRAL = "/referrals"
export const UPDATE_REFERRAL = "/referrals"

//DESIGNS
export const GET_DESIGNS = "/designs"
export const ADD_DESIGN = "/designs"
export const UPDATE_DESIGN = "/designs"
export const DELETE_DESIGN = "/designs"
export const GET_CUSTOM_CLIMATE = "/customclimate"
export const GET_CLIMATE_DATA = "/climate"
export const SET_CLIMATE_DATA = "/climate"
export const GET_PLANT_DATA = "/plants"
export const PLANT_SEARCH = "/plants"

// FREEBIES
export const GET_FREEBIE_PLANT_DATA = "/plantData"
export const GET_FREEBIE_CLIMATE_DATA = "/climateData"

export const STRUCTURES_SEARCH = "/structures"
export const GET_STRUCTURE_DATA = "/structures"

// AREAS
export const SEARCH_GUILD="/guilds"
export const GET_AREAS = "/areas"

// PLANT GUILDS
export const GET_USER_GUILDS = "/plant-guilds"
export const CREATE_USER_GUILD = "/plant-guilds"
export const UPDATE_USER_GUILD = "/plant-guilds"
export const DELETE_USER_GUILD = "/plant-guilds"
export const ADD_AREA = "/areas"
export const UPDATE_AREA = "/areas"
export const GET_CUSTOM_PLANTS = "/customplant"
export const UPDATE_CUSTOM_PLANT = "/customplant"
export const SAVE_CUSTOM_PLANT = "/customplant"
export const DELETE_CUSTOM_PLANT = "/customplant"
export const DELETE_AREA = "/areas"
export const GET_OBJECTIVES = "/objectives"
export const SAVE_OBJECTIVES = "/objectives"

export const GET_DATAENTRY_PLANTS="/hackathon/plant"
export const GET_DATAENTRY_ANIMALS="/hackathon/animal"
export const ADD_DATAENTRY_PLANT="/hackathon/plant"
export const ADD_DATAENTRY_ANIMAL="/hackathon/animal"
export const GET_LEADERBOARD="/hackathon/leaderboard"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = ""
export const GET_PROJECT_DETAIL = ""

// plant store
export const GET_PRIZES = "/plant-prizes"
export const ADD_REDEMPTION = "/redemptions"
export const UPDATE_REDEMPTION = "/redemptions"
export const GET_REDEMPTIONS_ACTIVITY = "/redemptions"
export const ADD_ACTIVITY = "/activity-internal"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const CREATE_NEW_USER = "/users"
